module.exports = __webpack_public_path__ + "img/dashboard-logo.3a19c4e3.svg";